import MContactSummaryBar from './index.vue';

MContactSummaryBar.install = app => {
  app.component(MContactSummaryBar.name, MContactSummaryBar);
};

export default MContactSummaryBar;
